__turbopack_context__.v({
  "photo-section": "photo-section-module-scss-module__G0WHga__photo-section",
  "photo-section__actions-container": "photo-section-module-scss-module__G0WHga__photo-section__actions-container",
  "photo-section__photo-container": "photo-section-module-scss-module__G0WHga__photo-section__photo-container",
  "photo-section__photo-cropper": "photo-section-module-scss-module__G0WHga__photo-section__photo-cropper",
  "photo-section__photo-cropper--hidden": "photo-section-module-scss-module__G0WHga__photo-section__photo-cropper--hidden",
  "photo-section__primary-actions-container": "photo-section-module-scss-module__G0WHga__photo-section__primary-actions-container",
  "photo-section__toggled-actions-container": "photo-section-module-scss-module__G0WHga__photo-section__toggled-actions-container",
});
